import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconShop: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21 9.047c.3 0 .6.1.8.398.2.2.2.499.2.797l-2.4 10.96c-.1.5-.5.798-1 .798H5.4c-.5 0-.9-.299-1-.797L2 10.243c0-.3 0-.598.2-.798.2-.298.5-.398.8-.398h2.2v-.1l3.7-5.48c.3-.399.9-.498 1.3-.299.5.3.6.897.3 1.395l-3 4.384h9l-3-4.384c-.3-.498-.2-1.096.3-1.395.5-.299 1.1-.2 1.4.3l3.7 5.48v.099H21zm-3.2 10.96l1.9-8.967H4.2l2 8.967h11.6zM9 17.516c0 .598-.4.996-1 .996s-1-.398-1-.996V13.53c0-.598.4-.996 1-.996s1 .398 1 .996v3.986zm3 .996c.6 0 1-.398 1-.996V13.53c0-.598-.4-.996-1-.996s-1 .398-1 .996v3.986c0 .598.4.996 1 .996zm5-.996c0 .598-.4.996-1 .996s-1-.398-1-.996V13.53c0-.598.4-.996 1-.996s1 .398 1 .996v3.986z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
